export default __webpack_public_path__ + "images/loggedout/icons/success-tick-49a593cfb04a8b042207cb952081b34d.png";